import { render } from "./VideoAccel.vue?vue&type=template&id=618ca794&ts=true"
import script from "./VideoAccel.vue?vue&type=script&lang=ts"
export * from "./VideoAccel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__